var ServiceStatusTypes = {
  NA: 0,
  SUSPENDED: 1,
  RUNNING: 2,
  DEPLOYING: 3,
  WAITING: 4,
  DELAYED: 5
};

module.exports = ServiceStatusTypes;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceStatusTypes.js